import { render, staticRenderFns } from "./fbxViewer.vue?vue&type=template&id=77ebb754&"
import script from "./fbxViewer.vue?vue&type=script&lang=js&"
export * from "./fbxViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77ebb754')) {
      api.createRecord('77ebb754', component.options)
    } else {
      api.reload('77ebb754', component.options)
    }
    module.hot.accept("./fbxViewer.vue?vue&type=template&id=77ebb754&", function () {
      api.rerender('77ebb754', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/fbxViewer.vue"
export default component.exports